<template>
  <Card
    dis-hover
    shadow
  >
    <div slot="title">
      <Button
        type="warning"
        :to="{name: 'add-login-number'}"
        class="mr-3"
      >
        <b>新增登入码</b>
      </Button>
      <Button
        type="success"
        :to="{name: 'login-number-related'}"
        class="mr-3"
      >
        <b>登入页码相关设定</b>
      </Button>
    </div>
    <lida-table
      :propscolumns="columns"
      :data="items"
    >
      <template v-slot:headerSelect>
        <span>站点入口：</span>
        <Select
          v-model="selectindex"
          style="width: 150px"
        >
          <Option
            v-for="it in select"
            :key="it.setpgid"
            :value="it.setpgid"
          >{{it.setpgname}}</Option>
        </Select>
      </template>
    </lida-table>
  </Card>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'login-number',
  data () {
    return {
      selectindex: '0',
      select: [{
        setpgid: "0",
        setpgname: "全部"
      }],
      items: [],
      columns: {
        setpgid: {
          title: "登入站编号",
          key: 'setpgid',
          align: "center"
        },
        setpgname: {
          title: "站名",
          key: 'setpgname',
          align: "center"
        },
        setlineid: {
          title: "页码编号",
          key: 'setlineid',
          align: "center"
        },
        incode: {
          title: "登入码",
          key: 'incode',
          align: "center",
          render: (h, params) => this.InputRender(h, params, 'incode')
        },
        tourl: {
          title: "导向网址",
          key: 'tourl',
          align: "center",
          render: (h, params) => this.InputRender(h, params, 'tourl')
        },
        guidetxt: {
          title: "备注",
          key: "guidetxt",
          align: "center",
          render: (h, params) => this.InputRender(h, params, 'guidetxt')
        },
        indexNumber: {
          title: "操作",
          key: 'indexNumber',
          align: "center",
          render: (h, params) => {
            const index = this.items.map(it => it.setlineid).indexOf(params.row.setlineid)
            const changestate = () => {
              return this.items[index].state = !this.items[index].state
            }

            if (params.row.state) {
              return h('span', [
                h('a', {
                  on: {
                    click: () => this.setlineupd(changestate)
                  }
                }, '储存'),
                h('Divider', { props: { type: 'vertical' } }, ''),
                h('a', {
                  on: {
                    click: () => {
                      Object.keys(this.form).forEach(it => this.form[it] = "")
                      changestate()
                    }
                  }
                }, '取消')
              ])
            } else {
              const insideStatus = params.row.tourl.indexOf("html") != -1
              const Divider = h('Divider', { props: { type: 'vertical' } }, '')
              const inside = h('a', {
                on: {
                  click: () => {
                    this.$router.push({ name: 'login-number-inside', params: { id: params.row.setlineid } })
                  }
                }
              }, '内页资讯')

              return h('span', [
                h('a', {
                  on: {
                    click: () => {
                      Object.keys(this.form).forEach(it => this.form[it] = params.row[it])
                      changestate()
                    }
                  }
                }, '编辑'),
                insideStatus ? Divider : null,
                insideStatus ? inside : null
              ])
            }
          }
        }
      },
      form: {
        setlineid: "",
        setpgid: "",
        incode: "",
        tourl: "",
        guidetxt: ""
      }
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  watch: {
    selectindex: 'getSitelist'
  },
  created () {
    this.getSiteSelect()
  },
  methods: {
    async getSiteSelect () {
      try {
        const res = await this.$axios.websiteManagement.getSiteSelect()
        if ('status' in res && res.status === 0) return
        this.select.push(...res)
        this.getSitelist()
      } catch (error) {
        console.error(error);
      }
    },
    async getSitelist () {
      try {
        const res = await this.$axios.websiteManagement.getSitelist(this.selectindex)
        if ('status' in res && res.status === 0) return
        this.items = res.map(it => {
          it.state = false
          return it
        })
      } catch (error) {
        console.error(error);
      }
    },
    async setlineupd (fun) {
      const check = Object.keys(this.form).some(it => this.form[it] == "")
      if (check) return this.$Message.warning("请勿空白");
      const incodeLength = this.form.incode.length >= 6
      const incodeCheck = /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(this.form.incode)
      if (!incodeCheck || !incodeLength) return this.$Message.error('最少需6码数字,英文或符号');
      try {
        const obj = {
          loid: this.getmember.pid,
          ...this.form
        }
        const res = await this.$axios.websiteManagement.setlineupd(obj)
        if (res.status == 1) {
          this.$Message.success('修改成功');
          this.getSitelist()
          Object.keys(this.form).forEach(it => this.form[it] = "")
        } else {
          fun()
        }
      } catch (error) {

      }
    },
    InputRender (h, params, key, type = 'text') {
      if (params.row.state) {
        return h('Input', {
          props: {
            value: params.row[key],
            type: type
          },
          on: {
            'on-change': ($event) => this.form[key] = $event.target.value
          }
        })
      } else {
        return h('span', params.row[key])
      }
    }
  }
}
</script>